module.exports = __webpack_public_path__ + "img/mali.c50aabcb.svg";